<template>
    <div class="portfolio-modal modal fade" id="showVideo" tabindex="-1" aria-labelledby="portfolioModal6"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0">
            <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center pb-5">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-8">
                  <!-- Portfolio Modal - Title-->
                  <h2 class="portfolio-modal-title text-secondary text-uppercase mb-0">
                    Gran Variedad de Piñatas
                  </h2>
                  <!-- Icon Divider-->                  
                  <!-- Portfolio Modal - Image-->
                  <video preload="none" loading="lazy" width="375" autoplay="false" poster="@/assets/img/poster.png"
                    muted="false" loop="false" src="@/assets/gran-Variedad-de-pinhatas-may.mp4" type="video/mp4"
                    controls></video>
                  <!-- Portfolio Modal - Text-->
                  <p class="mb-4">
                    Descubre la magia de nuestras piñatas, donde cada creación
                    es una explosión de color y alegría. Desde diseños
                    clásicos hasta las últimas tendencias, tenemos la piñata
                    perfecta para cada celebración. ¡Haz que tu fiesta sea
                    inolvidable con nuestras piñatas únicas!
                  </p>
                  <button class="btn btn-primary" data-bs-dismiss="modal">
                    <i class="fas fa-xmark fa-fw"></i>
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>